import { render, staticRenderFns } from "./barra-ventas.vue?vue&type=template&id=77f24349&scoped=true&"
import script from "./barra-ventas.vue?vue&type=script&lang=ts&"
export * from "./barra-ventas.vue?vue&type=script&lang=ts&"
import style0 from "./barra-ventas.vue?vue&type=style&index=0&id=77f24349&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f24349",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})
